













import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import { GetterNames } from '@/constants/GetterNames';
import { RouteNames } from '@/constants/RouteNames';
import {MutationNames} from '@/constants/MutationNames';

@Component({
  components: {
    Header,
  },
})
export default class App extends Vue {
  get isLoggedIn() {
    return this.$store.getters[GetterNames.IS_LOGGED_IN];
  }

  public doLogout() {
    this.$store.commit(MutationNames.LOG_OUT);
  }

  @Watch('isLoggedIn')
  public onIsLoggedIn(isLoggedIn: boolean) {
    if (isLoggedIn) {
      this.$router.push({
        name: RouteNames.DASHBOARD,
      });
    }
  }
}
